<template>
  <NuxtLayout
    name="generic"
    header="standardDark"
    footer="standard"
  >
    <div
      :class="{
        'blog-template mt-70px bg-www-color-neutral-off-white md:mt-120px': true,
        'max-md:[&>p.content]:text-sm': true,
      }"
    >
      <ResourceCenterLayout :content-type="'caseStudy'" />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import ResourceCenterLayout from '~/components/Organisms/ResourceCenterLayout/ResourceCenterLayout.vue';
</script>

<style></style>
